import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 当前企业已授权的品牌列表
export const setAuthBrandPage: Mutation<IModuleState> = (state, payload) => {
  state.authBrandPage.data = payload.data;
  state.authBrandPage.pageNum = payload.pageNum;
  state.authBrandPage.pageSize = payload.pageSize;
  state.authBrandPage.total = payload.total;
  state.authBrandPage.loading = !!payload.loading;
};

// 指定品牌下已授权的企业列表
export const setAuthOrgPage: Mutation<IModuleState> = (state, payload) => {
  state.authOrgPage.data = payload.data;
  state.authOrgPage.pageNum = payload.pageNum;
  state.authOrgPage.pageSize = payload.pageSize;
  state.authOrgPage.total = payload.total;
  state.authOrgPage.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 当前企业是否有owner品牌
export const setHasOwnerBrand: Mutation<IModuleState> = (state, payload) => {
  state.hasOwnerBrand = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
